import React from 'react';
import { Navigate } from 'react-router-dom';
import { HORAIRES, HOLIDAYS } from '@lba-dev/package.local-globals/AbsenDispo';
import {
  P_DEVIS,
  P_UPLOAD,
  P_OS,
  P_DISPO,
  P_ABILITY,
  P_PAIEMENTS,
  data as nPages,
} from '@lba-dev/package.local-globals/nPages';
import { ACCESS_GATE } from '@lba-dev/package.local-globals/accessGate';

import {
  InterFromMobile,
  Devis,
  PropositionArtisan,
  ArtisanHolidays,
  ArtisanUpload,
  SignPages,
  PropositionsDetail,
  Propositions,
  Faq,
  Profile,
  SousMetiers,
  Paiements,
  GrilleTarifaire,
  InstallApp,
  MesDevis,
} from '../views/artisans';

export default ({ pages }) =>
  (
    [
      {
        path: '/',
        component: Propositions,
        children: () => <Navigate to="/missions" />,
      },
      {
        // Legacy path, kept for SMS/mail links already sent referencing
        // nPages' P_DEVIS.route - new navigation should use /devis.
        path: '/artisanDevis',
        component: InterFromMobile,
        id: P_DEVIS,
      },
      {
        path: '/devis',
        component: InterFromMobile,
        id: P_DEVIS,
      },
      {
        path: '/devis/:id',
        component: Devis,
        id: P_DEVIS,
      },
      {
        path: '/mes-devis',
        component: MesDevis,
        id: P_DEVIS,
      },
      { path: '/artisanIntervention/:filter', component: PropositionArtisan },
      { path: '/artisanIntervention', component: PropositionArtisan },
      { path: '/missions', component: Propositions, id: P_OS },
      { path: '/missions/news', component: Propositions, id: P_OS },
      { path: '/missions/ongoing', component: Propositions, id: P_OS },
      {
        path: '/missions/history',
        component: Propositions,
        id: P_OS,
      },
      { path: '/missions/:id', component: PropositionsDetail, id: P_OS },
      {
        path: '/missions/:id/:filter',
        component: PropositionsDetail,
      },
      {
        path: '/availability',
        component: ArtisanHolidays,
        routes: [
          {
            path: '/disponible',
            component: ArtisanHolidays,
            componentProps: { type: HORAIRES },
          },
          {
            path: '/absence',
            component: ArtisanHolidays,
            componentProps: { type: HOLIDAYS },
          },
        ],
        id: P_DISPO,
      },
      { path: '/documents', component: ArtisanUpload, id: P_UPLOAD },
      { path: '/sign', component: SignPages },
      { path: '/faq', component: Faq },
      { path: '/profile', component: Profile },
      { path: '/installer', component: InstallApp },
      { path: '/sousMetiers', component: SousMetiers, id: P_ABILITY },
      { path: '/paiements', component: Paiements, id: P_PAIEMENTS },
      { path: '/ma-grille-tarifaire', component: GrilleTarifaire },
    ]
      .filter((e) =>
        pages.some((a) => {
          const { route, alias } = nPages.find((p) => p._id === a.id) || {};
          return (
            (((route && e.path.includes(route)) ||
            (alias && alias.some((p) => e.path.includes(p)))) &&
            a.enable) ||
          [
            '/', '/faq', '/profile', '/installer', '/ma-grille-tarifaire',
            ACCESS_GATE.resolvePath
          ].includes(
            e.path
          )
          );
        })
      )
      .reduce((v, c) => [...v, c, ...(c.routes || [])], []));
